import React, { useMemo } from 'react';
import { ClassType, PeriodType } from '../../../api';
import { Player } from '../../../services/references';
import styled from 'styled-components';
import SessionLineupsPlayer, { TLineupEntry } from './SessionLineupsPlayer';
import { TSession } from '../Sessions';
import { LineupReason } from '../../../services/sessionsUpload';

interface Props {
  width: number;
  header: string;
  lineup?: Array<TLineupEntry>;
  team?: string;
  session?: TSession;
  allPlayers: Array<string>;
  onChangeLineupEntry: (newEntry: TLineupEntry, prevEntry: TLineupEntry) => void;
  onDeleteSubstitution: (entry: TLineupEntry) => void;
  onDeleteRedCard: (entry: TLineupEntry) => void;
  onAddExit: (out: TLineupEntry, reason: LineupReason, outSeconds: number, period: PeriodType) => void;
  onAddSubstitution: (out: TLineupEntry, outSeconds: number, period: PeriodType, playerIn: Player) => void;
}

const SessionLineupsList: React.FunctionComponent<Props> = ({
  width,
  header,
  lineup,
  team,
  session,
  allPlayers,
  onChangeLineupEntry,
  onDeleteRedCard,
  onDeleteSubstitution,
  onAddSubstitution,
  onAddExit,
}) => {
  const teamPlayers = useMemo(() => {
    return lineup?.filter((entry) => entry.type === ClassType.HomePlayer || entry.type === ClassType.AwayPlayer) || [];
  }, [lineup]);

  const teamKeeper = useMemo(() => {
    return lineup?.filter((entry) => entry.type === ClassType.HomeKeeper || entry.type === ClassType.AwayKeeper) || [];
  }, [lineup]);

  const periods = useMemo(() => {
    return session?.periods?.map((p) => p.type as PeriodType) || [];
  }, [session]);

  return (
    <StartingContainer w={width}>
      <h2 style={{ fontSize: 24 }}>{header}</h2>
      <Table>
        <colgroup>
          <PrefixCol />
          <ShirtnumberCol />
          <PlayerCol />
          <IconsCol />
        </colgroup>
        <Body>
          {teamKeeper?.map((entry) => (
            <SessionLineupsPlayer
              key={entry.id}
              team={team}
              allPlayers={allPlayers}
              lineupEntry={entry}
              keeper
              periods={periods}
              onDeleteRedCard={onDeleteRedCard}
              onDeleteSubstitution={onDeleteSubstitution}
              onChange={onChangeLineupEntry}
              onAddExit={onAddExit}
              onAddSubstitution={onAddSubstitution}
            />
          ))}
          {teamPlayers?.map((entry) => (
            <SessionLineupsPlayer
              key={entry.id}
              team={team}
              keeper={false}
              allPlayers={allPlayers}
              lineupEntry={entry}
              periods={periods}
              onDeleteRedCard={onDeleteRedCard}
              onDeleteSubstitution={onDeleteSubstitution}
              onChange={onChangeLineupEntry}
              onAddExit={onAddExit}
              onAddSubstitution={onAddSubstitution}
            />
          ))}
        </Body>
      </Table>
    </StartingContainer>
  );
};

const PrefixCol = styled.col`
  width: 40px;
`;

const ShirtnumberCol = styled.col`
  width: 70px;
`;

const PlayerCol = styled.col``;

const IconsCol = styled.col`
  width: 150px;
`;

const Body = styled.tbody`
  width: 100%;
`;

const Table = styled.table`
  width: 100%;
`;

type ContainerProps = {
  w: number;
};

const StartingContainer = styled.div<ContainerProps>`
  flex-grow: 1;
  width: ${(props) => props.w + '%'};
`;
export default SessionLineupsList;
